import type { WritableSignal } from '@angular/core';
import { effect, untracked } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import type { OnyxChip } from '@onyx/angular';
import { linkedChipSignal } from '../utilities/linked-chip-signal';

interface ModalsState {
  _modals: Record<string, ModalState>;
}

interface ModalState {
  activeSection: ModalSection;
}

type ModalSection = [any];

export const ModalsStore = signalStore(
  { providedIn: 'root' },
  withState<ModalsState>({ _modals: {} }),
  withMethods((store) => ({
    getActiveSection<T>(
      modal: string,
      sections: () => OnyxChip<T>[],
    ): WritableSignal<[T]> {
      const lastActiveSection = store._modals()[modal]?.activeSection;
      const activeSection = linkedChipSignal(sections, lastActiveSection?.[0]);

      effect(() => {
        const section = activeSection();
        untracked(() => this._updateActiveSection(modal, section));
      });

      return activeSection;
    },

    _updateActiveSection(modal: string, section: ModalSection): void {
      patchState(store, (state) => ({
        _modals: {
          ...state._modals,
          [modal]: {
            ...(state._modals[modal] ?? {}),
            activeSection: section,
          },
        },
      }));
    },
  })),
);

export type ModalsStore = InstanceType<typeof ModalsStore>;
